import * as React from 'react';
import styled from 'styled-components';
import HeaderCardSection from '../common/HeaderCardSection';
import BbocHeroSvg from '../../../images/bboc/BbocHero.svg';
import { bbocWelcomeDescription } from '../../../core/bbocResultData';
import { OldCardContainer } from '../common/CardLayout';

const BbocWelcomeSubPage = ({ buttonText, onButtonClick }: Props) => {
	return (
		<CardContainerWrapper>
			<HeaderCardSection
				imageSrc={BbocHeroSvg}
				imageIsFullWidth={false}
				imageAlt="Be Better Off Challenge"
				title="Welcome to the Be Better Off Challenge"
				descriptions={bbocWelcomeDescription}
				titleFontSize="14px"
				descriptionFontSize="12px"
				buttonText={buttonText}
				onButtonClick={onButtonClick}
			/>
		</CardContainerWrapper>
	);
};

export default BbocWelcomeSubPage;

interface Props {
	buttonText: string;
	onButtonClick: () => void;
}

const CardContainerWrapper = styled(OldCardContainer)`
	padding: 19px 16px;
	justify-content: center;
`;
